{
  "error": "Error",
  "forbidden": "No access",
  "goToMain": "Go to the home page",
  "logout": "Log out",
  "notEnoughRights": "You don't have access to the page",
  "pageDoesNotExist": "There is no such page",
  "siteSleep": "Site is down",
  "thereIsNoPage": "There is no such page",
  "tryGoToMain": "Try going back to the main page and repeating the action",
  "tryRelogin": "Try logging in again or going back to the main page and repeating the action",
  "wrongLink": "The link you followed does not lead anywhere. There may have been a typo or the page may have been deleted."
}
